import { HttpErrorResponse } from '@angular/common/http';
import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { CleverTapEventsService } from '@commoncore/services/clevertap-events-service';
import { CustomMetadataService } from '@commoncore/services/custom-metadata.service';
import { GlobalService } from "@commoncore/services/global.service";
import { LocalStorageSvc } from '@commoncore/services/localStorage.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { Subject } from 'rxjs';
declare var Chart: any;
export class ProfileImplementation {
    public universalService: any;
	public router: any;
	public http: any;
    private localStorageSvc: LocalStorageSvc;
    cleverTapEventsService: CleverTapEventsService;
	static singleInstance: any = null;
	photo_percentage: any = 0;
	audio_percentage: any;
	video_percentage: any;
	other_percentage: any;
	event_percentage: any;
	emptyStorage_percentage: any;
	familyShare_percentage: any;
	customMetadata: any;
	public sortedPhotos: any = [];
	imageList:any =[];
	photopreviousLink: string;
	photosnextLink: any;
	profileImageModal: boolean = false;
	totalUploadedBytes: any;
	publicAlbumConsent: "Y" | "N" | "P";
	disabledLogoutBtn: boolean = false;
	sortedArray:any = {};
	p:any =[];
	modalType:any = "";
	lazyLoadImgService:any;
	listService:any;
	profilePicUploadComplete:Subject<boolean> = new Subject();
    constructor(public globalService:GlobalService) {	
		this.router=globalService.getRouterRef();
		this.http=globalService.getHttpClientRef();
		this.universalService=globalService.getUniversalServiceRef();
		this.listService = globalService.getListServiceRef();
		this.localStorageSvc = this.globalService.getLocalStorageSvcRef();
		this.cleverTapEventsService = globalService.getCleverTapEventsvc();
		this.customMetadata = new CustomMetadataService(this.universalService,this.listService);
		this.lazyLoadImgService = globalService.getLazyLoadImgServiceRef();
	}
	
	public static getInstance(globalService):ProfileImplementation{
		if(this.singleInstance == null){
		  this.singleInstance = new ProfileImplementation(globalService);
		  return this.singleInstance;
		}else{
		  return this.singleInstance;
		}
	}

	getUserPromotionDetails(){
		var classRef = this;
		const url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"] + ENV_CONFIG.commonUrls["getUserDetails"] + ENV_CONFIG.commonUrls["userPromotionsDetails"];
		return new Promise(function(resolve, reject){
			classRef.http.get(url).subscribe(
				(suc) => {
					resolve(suc);
				},
				(error:HttpErrorResponse) => { 
					classRef.universalService.showLoader = false;
					reject(error)
				},
			);
		})	
	}

	updateUserDetails(params){
		var classRef = this;
		const url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"]+  ENV_CONFIG.commonUrls["getUserDetails"];
		return new Promise(function(resolve, reject){
			classRef.http.put(url,params).subscribe(
				(suc) => {
					resolve(suc);
				},
				(error:HttpErrorResponse) => { 
					let errorObj = error.error;
					if (errorObj.errorCode === "TEJVF0002" || errorObj.errorCode === "SCLN0013" || errorObj.errorCode === "SCLN0010" || errorObj.errorCode === "TEJRF0500") {
						this.universalService.showLoader = false;
						this.universalService.showToast(TOAST["GENERIC_ERROR"], 'error');
					}
					reject(error);
				},
			);
		})
	}

	updateEmailID(email){
		var classRef = this;
		let params  = {     
			"emailId": email,
			"mobileNumber": " "
		}
		const url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"]+  ENV_CONFIG.commonUrls["verifyEmail"];
		return new Promise(function(resolve, reject){
			classRef.http.post(url,params).subscribe(
				(suc) => {
					classRef.universalService.showToast("Verification email has been sent to" + " " + email + ". " + "Please click on the link to verify your email", "success");
					resolve(suc);
				},
				(error:HttpErrorResponse) =>{
					let errrorObj = error.error;
					console.log("profile error",errrorObj)
					let msg = '';
					if (errrorObj.code === "SCLN0108" || errrorObj.code === "SCLN0109" || errrorObj.code === "SCLN0107") {
						msg = TOAST["MAX_EMAIL_VERIF_LIMIT_REACHED"];
					} else if (errrorObj?.error && (errrorObj.code === "SCLN0197" || errrorObj.code === "SCLN0198" || errrorObj.code === "SCLN0199" || errrorObj.code === "SCLN0200" || errrorObj.code === "SCLN0201" || errrorObj.code === "SCLN0401")) {
						msg = errrorObj?.error;
					} else {
						msg = TOAST["GENERIC_ERROR"];
					}
					classRef.universalService.showToast(msg,"error")
					reject(error)
				},
			);
		})
	}

	calculateStoragePercentage(userProfileDetails){
		if (userProfileDetails) {
			let photo ={'value':(userProfileDetails.quota.photoUsage / userProfileDetails.quota.totalAllocatedQuota) * 100,key:'photo'}
			let audio ={'value':(userProfileDetails.quota.audioUsage / userProfileDetails.quota.totalAllocatedQuota) * 100,key:'audio'}
			let video ={'value':(userProfileDetails.quota.videoUsage / userProfileDetails.quota.totalAllocatedQuota) * 100,key:'video'}
			let other ={'value':(userProfileDetails.quota.documentUsage / userProfileDetails.quota.totalAllocatedQuota) * 100,key:'other'}
			let event ={'value':(userProfileDetails.features.jioEvents.jioEventsUsedQuota / userProfileDetails.quota.totalAllocatedQuota) * 100,key:'event'}

			let familyshare = userProfileDetails.isFamilyMember == 'Y'? {'value':(userProfileDetails.quota.familyMembersUsedQuota / userProfileDetails.quota.totalAllocatedQuota) * 100,key:'familyshare'} : {'value':0,key:'familyshare'}
			let emptyStorage ={'value':100 -(photo.value + audio.value + video.value + other.value + event.value),key:'empty'}

			this.sortedArray = [photo,audio,video,other,emptyStorage,familyshare,event];
			this.sortedArray=this.sortedArray.sort((a, b) => {
				return  b.value - a.value ;
			});
			let totalvalue=0;
			this.sortedArray.map(function(type,index){
				if((type.value).toFixed(2)>0 && Math.floor(type.value)<=3){
					switch(index){
						case 0:
							type.perc = type.value;
							type.value = 7
							totalvalue= totalvalue + 7 - type.value;
						break;

						case 1:
						type.perc = type.value;
						type.value = 6
						totalvalue= totalvalue + 6 - type.value;
						break;

						case 2:
						type.perc = type.value;
						type.value = 5
						totalvalue= totalvalue + 5 - type.value;
						break;

						case 3:
						type.perc = type.value;
						type.value = 4
						totalvalue= totalvalue + 4 - type.value;
						break;

						case 4:
						type.perc = type.value;
						type.value = 3
						totalvalue= totalvalue + 3 - type.value;
						break;
						case 4:
						type.perc = type.value;
						type.value = 3
						totalvalue= totalvalue + 3 - type.value;
						break;
						case 6:
						type.perc = type.value;
						type.value = 2
						totalvalue= totalvalue + 2 - type.value;
						break;
						case 'default':
						console.log('default',index);
					}
				}
			})
			let allocatedSpace = this.transform(userProfileDetails.quota.totalAllocatedQuota,1)
			let usedSpace = this.transform(userProfileDetails.quota.totalUsedQuota,1)
			var self = this
			this.sortedArray.forEach(function (index) {
				index.value = index.value.toFixed(2)
				if(index.key == 'photo'){
					self.photo_percentage = index.value
				}else if(index.key == 'video'){
					self.video_percentage = index.value
				}else if(index.key == 'audio'){
					self.audio_percentage = index.value
				}else if(index.key == 'other'){
					self.other_percentage = index.value
				}else if(index.key == 'familyshare'){
					self.familyShare_percentage = index.value
				}else if(index.key == 'event'){
					self.event_percentage = index.value
				}else if(index.key == 'empty'){
					if(allocatedSpace == usedSpace || usedSpace > allocatedSpace){
						self.emptyStorage_percentage = 0
					}else{
						if(index.value>totalvalue)
							 index.value = index.value - totalvalue;
						self.emptyStorage_percentage = index.value
					}
					
					
				}
			});
		}
	}

	private units : Array<string> = ['B','KB','MB', 'GB', 'TB'];
  transform(value: any, decimal?:number): any {
      let unit = 0;
      let precision:number;
      while ( value >= 1024 && unit < 4) {
        value /= 1024;
        unit ++;
      }
      precision= unit == 0 ? 0 : decimal!= null && decimal!= undefined? decimal: 2;
      if(value != null && value != "") {
        value = value ==0 ? value.toFixed(precision) : value.toFixed(precision); 
        if(value % 1 == 0) {
          value =  Math.trunc(value);
        }
      }
      return value  + ' ' + this.units[unit];
  }
	getPhotosApi() {
		let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"]  + "?limit=100"+ "&filterCode=image&sort=%2DfileCreatedDate"
		this.http.get(url).subscribe(
		  suc => {
			this.getUserPhotos(suc);
		  },
		  err => {
			this.universalService.showErrorMessage(err);
		  }
		)
	}
	async getUserPhotos(suc){
		var self = this;
		this.photopreviousLink = "";
		if (suc["nextLink"]) {
		  this.photosnextLink = suc["nextLink"];
		} else {
		  this.photosnextLink = ""
		}
		if (this.sortedPhotos.length == 0) {
			this.imageList = await this.customMetadata.segregateData(suc, "photos");
			this.imageList.forEach((object)=>{
				let imageUrl = object["previewTranscodeUrl"];
				imageUrl = imageUrl.includes('?') ? imageUrl + '&': imageUrl + '?';
				let type = self.universalService.checkIfImgTypeParamIsRequired(object["mimeSubType"]);
				let url = imageUrl + "size=c&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + '&devicetype=web' + type;
				object["imageTranscodeUrl"] = url;
			});
		  	this.universalService.showLoader = false;
		  	this.bindScrollEvents();
		}
	}
	bindScrollEvents(){
		let classRef = this;
		let el = document.getElementById("profile-selection-main");
		if(el){
			el.onscroll = function(event){
			 	classRef.onPhotosBlockScroll(event)
			}
		}
	}
	async onPhotosBlockScroll(e){
		let self = this;
      	self.lazyLoadImgService.isScrollingStopped();
		let el = document.getElementById("profile-selection-main") as any;
		if ( el.scrollTop === (el.scrollHeight - el.offsetHeight)) {
			if(self.photosnextLink != "" && self.photopreviousLink != self.photosnextLink) {
				self.universalService.showLoader = true;
				self.photopreviousLink = self.photosnextLink;
				let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + self.photosnextLink
				await self.getNextPageData(url)
			}
		}
	}
	getNextPageData(url){
		this.http.get(url).subscribe(
			nextPageData => {
			  this.appendData(nextPageData);
			},
			err => {
			  this.universalService.showErrorMessage(err);
			}
		  )
	}
	appendData(nextPageData) {
		if (nextPageData["nextLink"]) {
		  this.photosnextLink = nextPageData["nextLink"];
		  if (this.photosnextLink.includes("sort=")) {
			if (this.photosnextLink.includes("sort=+")) {
			  this.photosnextLink=this.photosnextLink.replace("sort=+", "sort=%2B")
			}else if (this.photosnextLink.includes("sort=-")) {
			  this.photosnextLink=this.photosnextLink.replace("sort=-", "sort=%2D")
			}
		  }
		} else {
		  this.photosnextLink = "";
		}
		if(nextPageData["objects"]!=undefined && nextPageData["objects"].length>0 && this.universalService.emptyTab){
		  this.universalService.emptyTab = false;
		}
		var imageList = this.customMetadata.segregateData(nextPageData, "photos");
		this.imageList = this.imageList.concat(imageList);
		this.imageList.forEach((object)=>{
			let imageUrl = object["previewTranscodeUrl"];
			imageUrl = imageUrl.includes('?') ? imageUrl + '&': imageUrl + '?';
			let type = this.universalService.checkIfImgTypeParamIsRequired(object["mimeSubType"]);
			let url = imageUrl + "size=c&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + '&devicetype=web' + type;
			object["imageTranscodeUrl"] = url;
		});
		this.universalService.showLoader = false;
	}
	getImgBlob(url, type?){
		var self = this;
        return new Promise((resolve, reject) => {
            self.http.get(url, {responseType: 'blob'}).subscribe(
                response =>{  
                    // let blobdata = new Blob([response], type );
                    resolve(response);
                },
                error => {
					self.universalService.showLoader = false;
					if(error["status"] == 404){
						self.universalService.showToast(TOAST["GENERIC_ERROR"],"error")
					}
					self.universalService.disableModalBackdrop()
                    resolve("error");
                });  
        }); 
	}

	deviceArray(inputdevices,deviceId){
		let userData = this.localStorageSvc.getUserData(true);
		let devices:any=[];
		for(let pos=0;pos<inputdevices.length;pos++){
			let deviceData:any=[];
      //deviceData[0] = this.localStorageSvc.getDeviceKey(true) == inputdevices[pos].deviceKey?'':inputdevices[pos].deviceKey;//device key
		deviceData[0] = userData["deviceKey"] == inputdevices[pos].deviceKey?'':inputdevices[pos].deviceKey;//device key
      deviceData[1] = this.getDaynTime(inputdevices[pos].lastLoginDate);//last login
      deviceData[2] = inputdevices[pos].deviceType=='F'?"JioPhone":inputdevices[pos].model;//model
			deviceData[3] = inputdevices[pos].deviceType=='F'?"KaiOS":inputdevices[pos].platformType;//platformtype
			deviceData[4] = inputdevices[pos].deviceType;//deviceType
			deviceData[5] = inputdevices[pos].isWebClient;//isWebClient
			devices[pos] = deviceData
		}
		return devices;
	}

	public months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	getDaynTime(loginDate){
		let md= new Date(loginDate);
		return md.getDate() + " " + this.months[md.getMonth()] + " " + md.getFullYear() + ", " + md.getHours() + ":" + (md.getMinutes() < 10 ? '0' : '') + md.getMinutes();
	}
	
	updateProfilePhotoUI(obj){
		this.universalService.popUpToBeOpened = '';
		this.profileImageModal = false;
		this.universalService.disableModalBackdrop()
		this.removeOpacityIfThePreviousPictureIsFailed();
		this.universalService.showLoader = false;
		AppEvents.updateAuthData.next({updateProperty:true,property:{"key":"profileIconPhotoPath","value":obj['imageTranscodeUrl']}});
		this.universalService.setUpdateProfileIconPath();
		this.cleverTapEventsService.userProfileUpdate('PROFILE PIC')
	}

	removeOpacityIfThePreviousPictureIsFailed(){
		$('.profile-picture').removeAttr('style');
		$('#leftMenuDektopProfilePic').removeAttr('style');
		$('#leftMenuMobileProfilePic').removeAttr('style');
	}

	getPromotionEndDate(endDate) {
		var eDate = new Date(endDate);
		return (eDate.getDate() + " " + this.universalService.SHORT_MONTH_NAMES[eDate.getMonth()] + " " + eDate.getFullYear());
	}	

	getPhotos(showBackDrop){
		this.profileImageModal = true;
		this.universalService.popUpToBeOpened = 'dummy'
		this.universalService.showLoader = true;
		this.getPhotosApi();
		setTimeout(()=>{
		  if(this.universalService.isMobileDevice){
			this.setrRepoImageModalHeight();
		  }
		},500)
	}
	
	setrRepoImageModalHeight(){
	let img_cont = (document.querySelector('.profile-selection-main')) as any;
	let height = (window.innerHeight- (160 + $('.previewImgCont').outerHeight())).toString() + 'px';
	img_cont.style.height = height;
	}

	deleteAccount(){		
		let classRef = this;
		let params = {
			"status": "D", 
		};
		const url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"]+  ENV_CONFIG.commonUrls["accountDelete"];
		return new Promise(function(resolve, reject){
			classRef.http.put(url,params).subscribe(
				suc => {
					return resolve(suc);
				},
				error => {
					return reject(error);
				},
			);
		})
	}

	uploadProfilePic(url, formData,httpOptions){
		var self = this;
		return new Promise(function(resolve,reject){
			self.http.post(url, formData,httpOptions).subscribe(
				suc=>{
					if(suc.status == 201 && suc.body){
						self.profilePicUploadComplete.next(suc.body);
					}
					resolve(suc)
				},
				err=>{
					console.log("upload profilr pic",err);
					reject(err)
				}
			)
		})
	}
}